// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2dlbF","info":"UpdateTermsInfo_info__JpXG2"};